import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { mscGet, mscSet, store } from '@msc-b2c/shared-utils';

import App from './app/app';

const root = document.createElement('div');
root.id = 'mymsc-root';

document.body.appendChild(root);
const reactRoot = ReactDOM.createRoot(root as HTMLElement);

const onDocumentReady = () => {
  // Check if tab ID exists in sessionStorage
  // Every time you open a new tab and run this code, a new unique ID will be generated.
  // However, if you refresh the same tab, the ID will remain the same.
  if (!mscGet<string>('session', 'tabId')) {
    mscSet('session', 'tabId', Math.random().toString(36).substring(2, 11), 365);
  }

  reactRoot.render(
    <Provider store={store}>
      <StrictMode>
        <App />
      </StrictMode>
    </Provider>
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onDocumentReady);
} else {
  onDocumentReady();
}
